/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2Utbm90LWZvdW5kL3ByZXNlbnRhdGlvbi9wYWdlLW5vdC1mb3VuZC1ob21lL3BhZ2Utbm90LWZvdW5kLWhvbWUtY29udHJvbGxlci5jb21wb25lbnQuY3NzIn0= */"];
export { styles as styles };
